export function hexString (buffer) {
    const hexCodes = [...new Uint8Array(buffer)]
        .map(
            value => value.toString(16).padStart(2, "0")
        );
    return hexCodes.join("");
}

export default hexString;
